export const getFilterJurisdictions = (state) => state.jurisdictions;
export const getFilterListOfAgencies = (state) => state.agencies;
